export enum TipoCupom {
    PorUsuario = 1,
    PorEvento = 2,
  }